<script lang="ts">
  import { page } from '$app/stores';
  import { AnchorButtonSmall } from '$lib/components/anchor';
  import { AppPath } from '$lib/features/app';
  import { formatCompanyId } from '$lib/features/format';

  $: companyId = Number($page.params.companyId || $page.params.taxId?.slice(0, 8));
  $: taxId = $page.params.taxId;
</script>

<div class="mb-6 flex items-center">
  <AnchorButtonSmall
    display="hidden sm:flex"
    icon="building-2"
    href={AppPath.OFFICE}
    label="Empresas"
    padding="p-0"
    font="text-surface-600-300-token"
  />

  <AnchorButtonSmall
    display="flex sm:hidden"
    icon="building-2"
    href={AppPath.OFFICE}
    padding="p-0"
    font="text-surface-600-300-token"
  />

  <div class="text-surface-500-400-token mx-3 mb-0.5">&rsaquo;</div>

  <AnchorButtonSmall
    href={`${AppPath.COMPANY}/${companyId}`}
    label={formatCompanyId(Number(companyId))}
    padding="p-0"
    font={taxId ? 'text-surface-600-300-token' : ''}
  />

  {#if taxId}
    <div class="text-surface-500-400-token mx-3 mb-0.5">&rsaquo;</div>

    <AnchorButtonSmall
      href={`${AppPath.OFFICE}/${taxId}`}
      label={taxId.slice(8, 12) === '0001' ? 'Matriz' : `Filial ${taxId.slice(8, 12)}`}
      padding="p-0"
    />
  {/if}
</div>
